var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"head-top"},[_c('div',{staticClass:"top-container",attrs:{"id":"main-container"}},[_c('div',{staticClass:"top-left"}),_c('header-user')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }